<template>
  <component
    :is="component"
    :to="{
      name: 'course',
      params: {
        ...course
      }
    }"
    :href="externalLink ? course.product_url : null"
    class="home-course-card text-decoration-none"
    :class="{ pointer: course.product_url || !externalLink }"
    :target="externalLink ? '_blank' : '_self'"
  >
    <div
      class="card-img mb-3"
      :style="`background-image: url(${course.cover})`"
    >
      <div v-if="externalLink" class="icon-wrapper">
        <i class="icon-lock"></i>
      </div>
    </div>

    <div class="d-flex flex-column">
      <h6 class="text-light mb-0">{{ course.title }}</h6>
      <small class="text-secondary">{{ course.count_lessons }} AULAS</small>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      default: () => {}
    },
    externalLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    component() {
      return this.externalLink ? "a" : "router-link";
    }
  }
};
</script>

<style lang="scss" scoped>
.home-course-card {
  &.pointer {
    cursor: pointer;
  }

  .card-img {
    height: 0;
    width: 100%;
    display: block;
    padding-bottom: 55%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    position: relative;

    .icon-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100px;
      min-width: 100px;
      max-height: 100px;
      min-height: 100px;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);

      i {
        font-size: 60px;
        color: white;
      }
    }
  }
}
</style>
